import React, { useEffect, useState } from "react";
import { GetDownloads } from "../../store/Machines.store";
import { useAppDispatch } from "../../store/hooks";
import { IDownloads } from "../../interfaces";

// import filed from "../../ downloads/RenkoSignalStrategyV1.zip"

const DownloadStrategy: React.FC<{}> = () => {
  var dispatch = useAppDispatch();
  var strategiesList: IDownloads[] = [];
  const [downloads, setDownloads] = useState(strategiesList);

  useEffect(() => {
    dispatch(
      GetDownloads((data: IDownloads[]) => {
        setDownloads(data);
      })
    );
  }, [dispatch]);
  const downLoadfile = (fileName: any) => {
    // Create a link element to trigger the download
    const link = document.createElement("a");
    link.href =
      window.location.protocol +
      "//" +
      window.location.host +
      `/downloads/Strategies/${fileName}.zip`;
    link.download = `${fileName}.zip`;
    link.style.display = "none";
    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Remove the link from the body
    document.body.removeChild(link);
  };
  const navigateToUnlockLink = (url: any) => {
    // Create a link element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.style.display = "none";
    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Remove the link from the body
    document.body.removeChild(link);
  };
  return (
    <>
      <div className="">
        <h1>Download Strategies</h1>
      </div>
      <div>
        <br />
      </div>
      <div className="container ">
        <div className="grid grid-cols-1   md:grid-cols-2 xl:grid-cols-5 lg:grid-cols-3 gap-4">
          {downloads.map((item) =>
            item.isLocked ? (
              <div
                key={item.Id}
                onClick={() => {
                  navigateToUnlockLink(item.unlockLink);
                }}
                className="bg-gray-600   hover:cursor-pointer flex justify-center text-6xl rounded-xl blur-[3px]  "
              >
                {" "}
                
                  <img
                    alt=""
                    style={{    height: '200px'}}

                    className="object-scale-down p-4  m-auto"
                    src={`./downloads/SvgImage/${item.svgImage}`}
                  />
           
              </div>
            ) : (
              <div
                key={item.Id}
                onClick={() => {
                  downLoadfile(item.StrategyPackageName);
                }}
                className="    flex justify-center hover:cursor-pointer text-6xl border-2  rounded-xl  bg-gray-100 "
              >
                {" "}

                  <img
                    alt=""
                    style={{    height: '200px'}}
                    className="object-scale-down p-4  m-auto"
                    src={`./downloads/SvgImage/${item.svgImage}`}
                  />
              </div>
            )
          )}

        
        </div>
      </div>

      
    </>
  );
};

export default React.memo(DownloadStrategy);
